import { render, staticRenderFns } from "./Blue.vue?vue&type=template&id=27a8ffa0&lang=pug&"
import script from "./Blue.vue?vue&type=script&lang=ts&"
export * from "./Blue.vue?vue&type=script&lang=ts&"
import style0 from "./Blue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports